import React from 'react';
import { CheckSquare, FileCheck, Coins, Receipt } from 'lucide-react';

/**
 * Компонент секции дополнительной информации командировки
 */
const AdditionalInfoSection = ({ 
  formData, 
  handleInputChange,
  handleDocumentTypesChange, 
  errors,
  documentTypes
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/50 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <CheckSquare className="w-5 h-5 mr-2 text-indigo-500" />
        Дополнительная информация
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Подтверждающие документы */}
        <div className="col-span-full">
          <div className="flex items-center mb-2">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 flex items-center">
              <FileCheck className="w-4 h-4 mr-1 text-indigo-500" />
              Подтверждающие документы
            </label>
            <label className="inline-flex items-center ml-4">
              <input
                type="checkbox"
                name="includeDocuments"
                checked={formData.includeDocuments}
                onChange={handleInputChange}
                className="form-checkbox"
              />
              <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                Есть документы
              </span>
            </label>
          </div>
          
          {formData.includeDocuments && (
            <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-2">
              {documentTypes.map((docType) => (
                <label key={docType.id} className="inline-flex items-center">
                  <input
                    type="checkbox"
                    value={docType.id}
                    checked={formData.documentTypes.includes(docType.id)}
                    onChange={handleDocumentTypesChange}
                    className="form-checkbox"
                  />
                  <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                    {docType.name}
                  </span>
                </label>
              ))}
            </div>
          )}
          
          {formData.includeDocuments && errors.documentTypes && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.documentTypes}
            </p>
          )}
          
          {formData.includeDocuments && (
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
              Выберите типы документов, подтверждающих расходы. Наличие документов важно для компенсации расходов.
            </p>
          )}
        </div>

        {/* Аванс */}
        <div>
          <label htmlFor="advancePayment" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Coins className="w-4 h-4 mr-1 text-indigo-500" />
            Выданный аванс
          </label>
          <div className="flex">
            <input
              type="text"
              id="advancePayment"
              name="advancePayment"
              value={formData.advancePayment}
              onChange={handleInputChange}
              className="form-input w-full"
              placeholder="Введите сумму аванса"
            />
            <span className="inline-flex items-center px-3 border border-l-0 border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700 text-gray-500 dark:text-gray-400 text-sm rounded-r-md">
              ₽
            </span>
          </div>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Если был выдан аванс, укажите его сумму. Будет учтено при расчете к выплате.
          </p>
        </div>

        {/* Налоговый вычет */}
        <div>
          <div className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 flex items-center">
            <Receipt className="w-4 h-4 mr-1 text-indigo-500" />
            Налогообложение
          </div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="taxDeductible"
              checked={formData.taxDeductible}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать НДФЛ на сверхнормативные суточные
            </span>
          </label>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Если отмечено, НДФЛ 13% будет рассчитан с суммы превышения нормативов суточных.
          </p>
        </div>
      </div>

      {/* Информационный блок */}
      <div className="mt-4 bg-blue-50 dark:bg-blue-900/20 p-3 rounded-lg border border-blue-100 dark:border-blue-800">
        <p className="text-xs text-blue-700 dark:text-blue-300 flex items-start">
          <Receipt className="w-4 h-4 mt-0.5 mr-2 flex-shrink-0" />
          <span>
            Для полной компенсации расходов на командировку необходимо предоставить подтверждающие документы: билеты,
            посадочные талоны, чеки гостиниц и т.д. Служебные записки могут быть использованы в случае утери документов.
            Суточные выплачиваются независимо от наличия подтверждающих документов.
          </span>
        </p>
      </div>
    </div>
  );
};

export default AdditionalInfoSection;